<template>
  <div>
    <TableLayout title="پیام ها">
      <template #buttons>
        <b-button pill variant="info" class="ml-1 mb-1" v-b-modal.create-ticket>
          <b-icon icon="plus" class="mr-3" font-scale="1.5"/>
          ایجاد
        </b-button
        >
        <router-link :to="{ name: 'TrashTicket' }">
          <b-button pill variant="danger" class="ml-1 mb-1">
            <b-icon
                icon="trash"
                class="mr-1 my-1"
                font-scale="1.2"
            ></b-icon>
            سطل زباله
          </b-button>
        </router-link>
        <b-modal id="create-ticket" hide-footer size="lg">
          <div v-if="isAdmin" class="d-block mt-4 text-right">
            <input
                type="checkbox"
                id="for_other_users"
                value="for_other_users"
                v-model="checkbox_value"
            />
            <label class="mr-2" for="for_other_users">ارسال برای دیگران</label>
          </div>

          <div v-if="checkbox_value">
            <form-group v-if="isAdmin" :validations="$v.form.user_id">
              <div slot-scope="{ errors, invalid }">
                <label for="" class="mt-4 float-right"> کاربران </label>
                <b-form-input
                    class="col-lg-12"
                    v-model="searchOnUsers"
                    placeholder="نام، نام خانوادگی یا شماره تلفن کاربر"
                    @keyup.enter="searchUsers"
                />

                <div class="items mt-2">
                <span
                    class="d-block border-bottom cursor_pointer py-2 text-center "
                    v-for="user in users"
                    :class="{ 'btn btn-primary': user.id == form.user_id }"
                    @click="addUserToForm(user)"
                    :key="user.id"
                >
                  {{ user.name + " " + user.last_name }}
                </span>
                  <p v-if="users.length == 0" class="text-center">
                    هیچ کاربری یافت نشد!
                  </p>
                </div>
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>
          </div>

          <form @submit.prevent>
            <form-group :validations="$v.form.ticket_type">
              <div slot-scope="{ errors, invalid }">
                <label for="" class="mt-4 float-right"> نوع </label>
                <b-form-select v-model="form.ticket_type">
                  <option value="" selected>
                    نوع پیام را انتخاب کنید
                  </option>
                  <option v-for="(value, name) in ticket_types" :value="name">
                    {{ value }}
                  </option>
                </b-form-select>
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>

            <form-group class="mt-4" :validations="$v.form.ticket_subject">
              <div slot-scope="{ errors, invalid }">
                <label class="mt-4 float-right"> موضوع </label>
                <b-form-input v-model="form.ticket_subject"></b-form-input>
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>

            <form-group class="mt-4" :validations="$v.form.ticket_status">
              <div slot-scope="{ errors, invalid }">
                <label for="" class="mt-4 float-right">اولویت </label>
                <b-form-select v-model="form.ticket_status">
                  <option v-for="item in priorities" :value="item.id">
                    {{ item.meta_key }}
                  </option>
                </b-form-select
                >
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>

            <form-group class="mt-4" :validations="$v.form.ticket_description">
              <div slot-scope="{ errors, invalid }">
                <label for="" class="mt-4 float-right"> توضیحات </label>
                <b-form-textarea
                    id="textarea-small"
                    size="sm"
                    placeholder="پیام"
                    v-model="form.ticket_description"
                ></b-form-textarea>
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>

            <form-group class="mt-5" :validations="$v.form.files">
              <div slot-scope="{ errors, invalid }">

                <b-form-group>
                  <b-form-file v-model="form.files" multiple placeholder="" browse-text="انتخاب فایل"
                               id="file-default"></b-form-file>
                </b-form-group>
                <form-errors-manager class="float-right" :errors="errors"/>
              </div>
            </form-group>

            <div class="ml-1 mt-3">
              <b-button pill class="ml-1" @click="$bvModal.hide('create-ticket')">
                بستن
              </b-button
              >

              <b-btn variant="success" @click="onSubmit" pill type="submit">
                ارسال
              </b-btn>
            </div>
          </form>
        </b-modal>

      </template>

      <template #table>
        <b-table
            v-bind="tableAttributes"
            :fields="fields"
            :items="getTickets"
        >
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>
          <template #cell(priority)="data">
            {{ data.item.priority.meta_key }}
          </template>
          <template #cell(status)="data" v-if="isAdmin">
            <select
                v-model="data.item.status.id"
                class="form-select custom-select"
                @change="ChangeStatus(data, $event)"
            >
              <option v-for="status in statuses" :value="status.id">
                {{ status.meta_key }}
              </option>
            </select>
          </template>
          <template #cell(status)="data" v-else>
            {{ data.item.status }}
          </template>
          <template #cell(type)="data">
            {{ ticket_types[data.item.ticket_type] }}
          </template>
          <template #cell(function)="data">
            {{ data.item.function }}

            <span v-if="isAdmin" class="h5" v-b-tooltip.hover title="حذف">
          <b-icon
              icon="trash"
              class="ml-2"
              @click="deleteTicket(data.item)"
          ></b-icon>
        </span>

            <span class="h5" v-b-tooltip.hover title="پیام">
          <router-link
              :to="{
              name: 'TicketMessages',
              params: { ticket: data.item.id, user: data.item.user.id },
            }"
          ><b-icon icon="chat-left-text"
          /></router-link>
        </span>
          </template>
        </b-table>
        <div class="row pt-3">
          <div class="mt-3 color" style="margin: auto">
            <pagination :meta="paginationMeta" :on-change-page="changePage"/>
          </div>
        </div>
      </template>

    </TableLayout>
  </div>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {required} from "vuelidate/lib/validators";
import FormGroup from "../../components/validator/FormGroup.vue";
import FormErrorsManager from "../../components/validator/FormErrorsManager.vue";
import {mapGetters} from "vuex";
import Pagination from "../../components/dashboard/Pagination.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import {ticket_types} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Ticket";
import TableLayout from "../../components/dashboard/TableLayout";

export default {
  name: "tableItems",
  props: ["restoreState"],
  components: {FormGroup, FormErrorsManager, Pagination, TableLayout},
  data() {
    return {
      checkbox_value: "",
      searchOnUsers: "",
      tableAttributes: {...tableAttributes, ...{responsive: "xl"}},
      ticket_types,
      fields: [
        {key: "name", label: "عنوان"},
        {key: "priority", label: "اولویت"},
        {key: "status", label: "وضعیت"},
        {key: "type", label: "نوع"},
        {key: "function", label: "عملیات"},
      ],
      form: {
        user_id: "",
        ticket_type: "",
        ticket_subject: "",
        ticket_description: "",
        ticket_status: "",
        files: []
      },
      priorities: [],
      statuses: [],
    };
  },
  validations: {
    form: {
      user_id: {},
      ticket_type: {required},
      ticket_subject: {required},
      ticket_description: {required},
      ticket_status: {required},
      files: {}
    },
  },
  computed: {
    ...mapGetters({
      getTickets: "Ticket/getTickets",
      paginationMeta: "Ticket/getPaginationMeta",
      isAdmin: "User/isAdmin",
      users: "User/getPersons",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.checkbox_value) {
          if (this.form.user_id == "") {
            toast("خطا", "کاربری را انتخاب کنید", "danger");
            return false;
          }
        }
        this.$store.dispatch("Ticket/createticket", this.form);
      }
    },
    searchUsers() {
      if (this.searchOnUsers.trim() !== "") {
        const form = {
          words: this.searchOnUsers,
        };
        this.$store.dispatch("User/searchUsers", form);
      }
    },
    addUserToForm(user) {
      this.form.user_id = user.id;
    },
    changePage(page) {
      this.page = page;
      this.$store.dispatch("Ticket/getTickets", page);
    },
    deleteTicket(ticket) {
      if (confirm("آیا از حذف این پیام اطمینان دارید؟")) {
        const page = this.page;
        this.$store.dispatch("Ticket/deleteTicket", {ticket, page});
      }
    },

    swap(arr, xp, yp) {
      var temp = arr[xp];
      arr[xp] = arr[yp];
      arr[yp] = temp;
    },

    bubbleSort(arr) {
      var i, j;
      for (i = 0; i < arr.length - 1; i++) {
        for (j = 0; j < arr.length - i - 1; j++) {
          if (parseInt(arr[j].value) > parseInt(arr[j + 1].value)) {
            this.swap(arr, j, j + 1);
          }
        }
      }
      this.priorities = arr;
    },
    ChangeStatus(data) {
      const form = {status: data.item.status.id};
      this.$store.dispatch("Ticket/UpdateTicket", {
        form: form,
        ticket_id: data.item.id,
      });
    },
  },
  async mounted() {
    if (this.isAdmin) {
      this.$store.dispatch("Ticket/getTickets");
      const requestOptions = {
        name: "priority",
        metaable_type: "ticket",
      };
      this.priorities = await this.$store.dispatch(
          "Meta/showCustomMeta",
          requestOptions
      );
      this.priorities = this.priorities.data.data;

      const requeststatusess = {
        name: "status",
        metaable_type: "ticket",
      };
      this.statuses = await this.$store.dispatch(
          "Meta/showCustomMeta",
          requeststatusess
      );
      this.statuses = this.statuses.data.data;
      this.$store.dispatch("User/getPersons");
    } else {
      this.$store.dispatch("Ticket/getUserTickets");
    }

  },
};
</script>
<style scoped>
.cursor_pointer {
  cursor: pointer;
}

span:hover {
  color: rgb(94, 77, 194);
}

.items {
  height: 200px !important;
  overflow-y: scroll;
}

</style>